import { Box, CircularProgress, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { analytics, events } from 'services/analytics';
import { remixerApi } from 'services/api/remixer';
import { selectCurrentProjectId } from 'services/store/remixer/selectors';
import Remixer from './Remixer';

type ProjectRouteParams = { projectId: string };

const RemixerProjectContainer = () => {
  const theme = useTheme();

  const currentProjectId = useSelector(selectCurrentProjectId);
  const { projectId } = useParams<ProjectRouteParams>() as ProjectRouteParams;

  const { isLoading, error } = remixerApi.useGetProjectQuery(projectId, {
    skip: projectId === currentProjectId,
  });

  useEffect(() => {
    if (error) {
      analytics.track(events.studioError(error));
    }
  }, [error]);

  if (isLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress color="primary" size={theme.spacing(8)} />
      </Box>
    );
  }

  if (error) {
    return <Box>request project error</Box>;
  }

  return <Remixer />;
};

export default RemixerProjectContainer;
